import React from 'react';
import ReactDOM from 'react-dom';
//import App from './App';
import App from './eebac/App';

ReactDOM.render(<App />, document.getElementById('root'));